import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// components
import { ClientsComponent } from './clients.component';
import { MatIconModule } from '@angular/material/icon';
import { ComponentsModule } from '../../components/component.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MenuModule } from 'primeng/menu';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { SubSidebarModule } from 'projects/access-control/src/app/UI/commons/sub-sidebar/sub-sidebar.module';
import { ComponentsClientModule } from './components/components-client.module';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { loadingSpinnerModule } from 'projects/access-control/src/app/UI/commons/loading-spinner/loading-spinner.module';
import { TooltipModule } from 'primeng/tooltip';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';
import { BreadcrumbModule } from 'projects/access-control/src/app/UI/commons/breadcrumb/breadcrumb.module';
import { NgxCodejarModule } from 'ngx-codejar';

const routes: Routes = [
	{
		path: '',
		component: ClientsComponent,
	},
];

@NgModule({
	declarations: [ClientsComponent],
	exports: [ClientsComponent],
	imports: [
		SubSidebarModule,
		CommonModule,
		RouterModule.forChild(routes),
		MatIconModule,
    NgxCodejarModule,
		ComponentsClientModule,
		ComponentsModule,
		CommonsModule,
		BreadcrumbModule,
		FormsModule,
		MatDialogModule,
		FormsModule,
		DirectivesModule,
		loadingSpinnerModule,
		PipesModule,
		MenuModule,
		TooltipModule,
		MatTooltipModule,
	],
	providers: [DatePipe],
})
export class ClientsModule {}
